module.exports = __webpack_public_path__ + "img/payments.daily.ed81ca1e.png";